import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toArray from "@babel/runtime/helpers/toArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var _excluded = ["fieldId", "fieldName", "fieldAriaLabel", "customRowRenderer", "disabled", "error", "label", "onBlur", "onFocus", "optionsTitle", "position", "showOptions", "showSuggestions", "stack", "styleSheet", "tabIndex", "warning", "width", "fieldTooltip", "fieldTooltipDoNotFold", "arrow", "borderless", "autoCapitalize", "autoComplete", "autoCorrect", "spellCheck", "options", "value", "noMatchTitle", "allowCustomValue", "searchFunction", "onChange", "onSearch", "clearSelectionOnStartTyping"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import ActionIconChevronBottom from '@bubble-ui/icon-action-chevron-bottom';
import Field from '@bubble-ui/molecule-field-regular';
import { compose, setDisplayName, defaultProps } from 'recompose';
import { setPropTypes, PropTypes } from 'proper-types';
import View from '@bubble-ui/primitive-view';
import { BASE, TOOLTIP } from '@bubble-ui/particle-layers';
import wrapOverridableComponent from '@bubble-ui/hoc-wrap-overridable-component';
import { equals } from 'ramda';
import withPropDeprecationWarning from '@bubble-ui/hoc-with-prop-deprecation-warning';
import Dropdown from './dropdown';
var NAVIGATION_KEYS = {
  ArrowUp: 'ArrowUp',
  ArrowDown: 'ArrowDown'
};

var getDefaultStyleSheet = function getDefaultStyleSheet() {
  return {
    row: {
      item: {
        borderBottom: '1px solid rgb(233, 233, 232)',
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '100%',
        justifyContent: 'center'
      },
      textWrapper: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: '90%',
        display: 'block'
      },
      searchHighlightStyle: {
        fontWeight: 'bold',
        background: '#F2F2F1',
        textTransform: 'capitalize'
      }
    },
    dropdown: {
      containerStyle: {
        position: 'absolute',
        top: '58px',
        left: '5px',
        right: '5px',
        zIndex: TOOLTIP,
        boxShadow: '0px 3px 15px rgba(0, 0, 0, 0.15)'
      },
      maxHeight: 305,
      lineHeight: 61
    }
  };
};

var cleanString = function cleanString(input) {
  return input.trim().toLowerCase();
};

function leftSearch() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var lowString = cleanString(string);
  var lowSearch = cleanString(search);

  if (lowString.substring(0, lowSearch.length) === lowSearch) {
    return true;
  }

  return false;
}

export function getMatchingSuggestions() {
  var itemList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var searchString = arguments.length > 1 ? arguments[1] : undefined;

  if (!Array.isArray(itemList) || !itemList.length || !searchString || searchString === '') {
    return [];
  }

  var clearnSearchString = cleanString(searchString);

  if (itemList[0].options.hint) {
    itemList.shift();
  }

  return itemList.filter(function (_ref) {
    var _ref$item = _ref.item,
        _ref$item$label = _ref$item.label,
        label = _ref$item$label === void 0 ? '' : _ref$item$label,
        _ref$item$alternative = _ref$item.alternatives,
        alternatives = _ref$item$alternative === void 0 ? [] : _ref$item$alternative;
    return [label].concat(_toConsumableArray(alternatives)).some(function (alternative) {
      return leftSearch(alternative, clearnSearchString);
    });
  });
}
export var getHighlightMatch = function getHighlightMatch(defaultHighlightStyle) {
  return function (label, searchString) {
    var highlightStyle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultHighlightStyle;
    var matches = leftSearch(label, searchString);

    if (matches) {
      var cleanSearch = cleanString(searchString);
      var rest = label.slice(cleanSearch.length);
      return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
        style: highlightStyle
      }, cleanSearch), rest);
    }

    return label;
  };
};

var Combobox = /*#__PURE__*/function (_React$Component) {
  _inherits(Combobox, _React$Component);

  var _super = _createSuper(Combobox);

  function Combobox(props) {
    var _this;

    _classCallCheck(this, Combobox);

    _this = _super.call(this, props);
    _this.state = {
      focused: false,
      selectedOption: props.value ? props.value : null,
      searchString: '',
      lastSelectedItem: null,
      focusedElementIndex: null,
      options: _this.generateOptions()
    };
    _this.handleOnChange = _this.handleOnChange.bind(_assertThisInitialized(_this));
    _this.handleOnSearch = _this.handleOnSearch.bind(_assertThisInitialized(_this));
    _this.onKeyDownHandler = _this.onKeyDownHandler.bind(_assertThisInitialized(_this));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    _this.blur = _this.blur.bind(_assertThisInitialized(_this));
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_this));
    _this.maybeSelectBestSuggestion = _this.maybeSelectBestSuggestion.bind(_assertThisInitialized(_this));
    _this.onEnter = _this.onEnter.bind(_assertThisInitialized(_this));
    _this.ref = /*#__PURE__*/React.createRef();
    _this.generateOptions = _this.generateOptions.bind(_assertThisInitialized(_this));
    _this.shouldBlur = _this.shouldBlur.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Combobox, [{
    key: "shouldBlur",
    value: function shouldBlur(event) {
      if (this.state.focused && !this.props.disabled && (this.ref.current && !this.ref.current.contains(event.target) || event.key === 'Tab')) {
        this.onBlur();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.shouldBlur);
      document.addEventListener('keyup', this.shouldBlur);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.shouldBlur);
      document.removeEventListener('keyup', this.shouldBlur);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var newState = {};

      if (!equals(prevProps.options, this.props.options)) {
        newState.options = this.generateOptions(this.state.searchString);
      }

      if (!equals(prevProps.value, this.props.value)) {
        newState.selectedOption = this.props.value;
        this.setState({
          selectedOption: newState.selectedOption
        });
      }

      if (newState.options || newState.selectedOption) {
        this.setState(newState);
      }
    }
  }, {
    key: "generateOptions",
    value: function generateOptions() {
      var searchString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var _this$props = this.props,
          options = _this$props.options,
          _this$props$noMatchTi = _this$props.noMatchTitle,
          noMatchTitle = _this$props$noMatchTi === void 0 ? '' : _this$props$noMatchTi,
          allowCustomValue = _this$props.allowCustomValue;
      var newOptions = options.map(function (item) {
        return {
          item: item,
          options: {}
        };
      });

      if (searchString !== '') {
        var suggestionsToRender = this.props.searchFunction(newOptions, searchString);

        if (suggestionsToRender.length > 0) {
          newOptions = suggestionsToRender;
        } else if (allowCustomValue) {
          newOptions.unshift({
            item: {
              label: searchString,
              value: searchString
            },
            options: {
              customValue: true
            }
          });
        } else {
          var _noMatchTitle$split = noMatchTitle.split('|SEARCH|'),
              _noMatchTitle$split2 = _toArray(_noMatchTitle$split),
              firstPart = _noMatchTitle$split2[0],
              restParts = _noMatchTitle$split2.slice(1);

          var label = /*#__PURE__*/React.createElement("span", null, firstPart, " ", /*#__PURE__*/React.createElement("b", null, searchString), " ", restParts.concat(''));
          newOptions.unshift({
            item: {
              label: label,
              value: null
            },
            options: {
              hint: true
            }
          });
        }
      }

      return newOptions;
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      if (!this.state.focused) {
        this.setState({
          focused: true,
          searchString: ''
        });
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      var allowCustomValue = this.props.allowCustomValue;
      var _this$state = this.state,
          selectedOption = _this$state.selectedOption,
          searchString = _this$state.searchString,
          lastSelectedItem = _this$state.lastSelectedItem;
      var selectedBestSuggestion = this.maybeSelectBestSuggestion();

      if (!selectedBestSuggestion) {
        if (allowCustomValue && selectedOption === null) {
          this.handleOnChange({
            item: {
              label: searchString,
              value: searchString
            },
            options: {},
            customValue: true
          });
        } else if (selectedOption === null && lastSelectedItem !== null) {
          // Fallback to previous selected item if nothing else  matches
          this.setState({
            selectedOption: lastSelectedItem
          });
        }
      }

      this.blur();
    }
  }, {
    key: "blur",
    value: function blur() {
      var _this$state2 = this.state,
          selectedOption = _this$state2.selectedOption,
          searchString = _this$state2.searchString;
      var allowCustomValue = this.props.allowCustomValue;
      this.setState({
        focused: false,
        searchString: allowCustomValue && !selectedOption ? searchString : '',
        focusedElementIndex: null
      });
    }
  }, {
    key: "onEnter",
    value: function onEnter() {
      if (this.state.focused) {
        if (this.props.allowCustomValue) {
          this.onBlur();
        } else {
          this.maybeSelectBestSuggestion();
        }
      }
    }
  }, {
    key: "maybeSelectBestSuggestion",
    value: function maybeSelectBestSuggestion() {
      var _this$state3 = this.state,
          selectedOption = _this$state3.selectedOption,
          searchString = _this$state3.searchString,
          focusedElementIndex = _this$state3.focusedElementIndex,
          options = _this$state3.options;
      var allowCustomValue = this.props.allowCustomValue;

      if (focusedElementIndex !== null) {
        this.handleOnChange(options[focusedElementIndex]);
        this.blur();
        return true;
      }

      if (allowCustomValue && options !== null && options !== void 0 && options.length && searchString === options[0].item.value) {
        this.handleOnChange(options[0]);
        this.blur();
        return true;
      }

      var matchingSuggestions = this.props.searchFunction(options, searchString);

      if (!allowCustomValue && selectedOption === null && matchingSuggestions.length > 0) {
        this.handleOnChange(matchingSuggestions[0]);
        this.blur();
        return true;
      }

      return false;
    }
  }, {
    key: "handleOnChange",
    value: function handleOnChange(newSelection) {
      this.setState({
        searchString: '',
        options: this.generateOptions(''),
        selectedOption: newSelection,
        lastSelectedItem: newSelection
      });
      var _this$props$onChange = this.props.onChange,
          onChange = _this$props$onChange === void 0 ? null : _this$props$onChange;
      var item = newSelection.item;
      var _newSelection$options = newSelection.options.customValue,
          customValue = _newSelection$options === void 0 ? false : _newSelection$options;

      if (onChange) {
        onChange({
          item: item,
          customValue: customValue
        });
      }

      this.blur();
    }
  }, {
    key: "handleOnSearch",
    value: function handleOnSearch(newSearch) {
      this.setState({
        selectedOption: null,
        searchString: newSearch,
        options: this.generateOptions(newSearch)
      });
      this.props.onSearch(newSearch);
    }
  }, {
    key: "onKeyDownHandler",
    value: function onKeyDownHandler(event) {
      this.onFocus();
      var key = event.key;
      var _this$props2 = this.props,
          allowCustomValue = _this$props2.allowCustomValue,
          clearSelectionOnStartTyping = _this$props2.clearSelectionOnStartTyping;
      var _this$state4 = this.state,
          selectedOption = _this$state4.selectedOption,
          focusedElementIndex = _this$state4.focusedElementIndex,
          lastSelectedItem = _this$state4.lastSelectedItem,
          options = _this$state4.options;

      if (key === 'Escape') {
        this.setState({
          focused: false,
          selectedOption: lastSelectedItem,
          searchString: ''
        });
        return;
      }

      var optionNavigationAttempt = false;

      if (key === NAVIGATION_KEYS.ArrowUp || key === NAVIGATION_KEYS.ArrowDown) {
        event.preventDefault();
        optionNavigationAttempt = true;
      }

      var newState = {};

      if (key === NAVIGATION_KEYS.ArrowDown) {
        if (focusedElementIndex === null) {
          newState.focusedElementIndex = !allowCustomValue && options[0].options.hint ? 1 : 0;
        } else if (focusedElementIndex < options.length - 1) {
          newState.focusedElementIndex = focusedElementIndex + 1;
        }
      } else if (key === NAVIGATION_KEYS.ArrowUp && focusedElementIndex >= 1) {
        if (!allowCustomValue && options[0].options.hint && focusedElementIndex === 1) {
          newState.focusedElementIndex = focusedElementIndex;
        } else {
          newState.focusedElementIndex = focusedElementIndex - 1;
        }
      } // If there is a selected option and the user starts typing, clear out current selection


      if (clearSelectionOnStartTyping && !optionNavigationAttempt) {
        newState.focusedElementIndex = null;

        if (selectedOption) {
          newState.selectedOption = null;
          newState.lastSelectedItem = selectedOption;

          if (allowCustomValue) {
            newState.searchString = '';
          }
        }
      }

      if (Object.keys(newState).length > 0) {
        this.setState(newState);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state5 = this.state,
          focused = _this$state5.focused,
          searchString = _this$state5.searchString,
          selectedOption = _this$state5.selectedOption,
          focusedElementIndex = _this$state5.focusedElementIndex,
          options = _this$state5.options;
      var renderValue = '';

      if (selectedOption) {
        var _label = selectedOption.label || selectedOption && selectedOption.item && selectedOption.item.label || '';

        renderValue += _label;
      } else {
        renderValue = searchString;
      }

      var width = this.ref.current ? this.ref.current.getBoundingClientRect().width : 0;

      var _this$props3 = this.props,
          fieldId = _this$props3.fieldId,
          fieldName = _this$props3.fieldName,
          fieldAriaLabel = _this$props3.fieldAriaLabel,
          customRowRenderer = _this$props3.customRowRenderer,
          disabled = _this$props3.disabled,
          error = _this$props3.error,
          label = _this$props3.label,
          onBlur = _this$props3.onBlur,
          onFocus = _this$props3.onFocus,
          optionsTitle = _this$props3.optionsTitle,
          position = _this$props3.position,
          showOptions = _this$props3.showOptions,
          showSuggestions = _this$props3.showSuggestions,
          stack = _this$props3.stack,
          styleSheet = _this$props3.styleSheet,
          tabIndex = _this$props3.tabIndex,
          warning = _this$props3.warning,
          fieldWidth = _this$props3.width,
          fieldTooltip = _this$props3.fieldTooltip,
          fieldTooltipDoNotFold = _this$props3.fieldTooltipDoNotFold,
          arrow = _this$props3.arrow,
          borderless = _this$props3.borderless,
          autoCapitalize = _this$props3.autoCapitalize,
          autoComplete = _this$props3.autoComplete,
          autoCorrect = _this$props3.autoCorrect,
          spellCheck = _this$props3.spellCheck,
          optionsProp = _this$props3.options,
          value = _this$props3.value,
          noMatchTitle = _this$props3.noMatchTitle,
          allowCustomValue = _this$props3.allowCustomValue,
          searchFunction = _this$props3.searchFunction,
          onChange = _this$props3.onChange,
          onSearch = _this$props3.onSearch,
          clearSelectionOnStartTyping = _this$props3.clearSelectionOnStartTyping,
          otherProps = _objectWithoutProperties(_this$props3, _excluded);

      var renderDropdown = focused && !disabled;

      var fieldProps = _objectSpread({
        id: fieldId,
        name: fieldName || label,
        label: label,
        'aria-label': fieldAriaLabel,
        onChange: this.handleOnSearch,
        onKeyDown: this.onKeyDownHandler,
        value: renderValue,
        onEnter: this.onEnter,
        position: position,
        stack: stack,
        tabIndex: tabIndex,
        width: fieldWidth,
        disabled: disabled,
        warning: warning,
        error: error,
        onFocus: onFocus,
        onBlur: onBlur,
        arrow: arrow || 'top-right',
        fieldTooltipDoNotFold: fieldTooltipDoNotFold,
        fieldTooltip: disabled ? fieldTooltip : undefined,
        autoCapitalize: autoCapitalize,
        autoComplete: autoComplete,
        autoCorrect: autoCorrect,
        spellCheck: spellCheck
      }, otherProps);

      var chevronStyles = {
        pointerEvents: 'none',
        zIndex: renderDropdown ? TOOLTIP + 1 : BASE,
        // high enough so that opening won't make it invisible, but only when dropdown is opened, avoiding to impact other instances of the component
        position: 'absolute',
        right: borderless ? 0 : 12,
        top: 20,
        cursor: 'pointer'
      };
      var iconProps = ' ';

      if (warning || error || focused) {
        iconProps = {
          colorToken: 'colors/text/default'
        };
      } else if (disabled) {
        iconProps = {
          colorToken: 'colors/text/default',
          colorTokenArgs: {
            interactiveState: 'disabled'
          }
        };
      } else {
        iconProps = {
          colorToken: 'colors/text/neutral'
        };
      }

      return /*#__PURE__*/React.createElement(View, {
        "data-cid": this.props['data-cid'],
        onFocus: disabled ? undefined : this.onFocus,
        onMouseDown: this.onFocus,
        style: {
          position: 'relative',
          zIndex: renderDropdown && TOOLTIP
        }
      }, /*#__PURE__*/React.createElement("div", {
        ref: this.ref,
        style: {
          position: 'relative'
        }
      }, borderless ? /*#__PURE__*/React.createElement(Field, _extends({
        isUnderlined: true
      }, fieldProps)) : /*#__PURE__*/React.createElement(Field, fieldProps), !(disabled && fieldTooltip) && /*#__PURE__*/React.createElement("div", {
        style: chevronStyles
      }, /*#__PURE__*/React.createElement(ActionIconChevronBottom, iconProps)), renderDropdown && /*#__PURE__*/React.createElement(Dropdown, {
        styleSheet: styleSheet,
        width: width,
        focusedElementIndex: focusedElementIndex,
        itemList: options,
        searchString: searchString,
        onSelectSuggestion: this.handleOnChange,
        showSuggestions: showSuggestions,
        showOptions: showOptions,
        optionsTitle: optionsTitle,
        customRowRenderer: customRowRenderer,
        highlightMatch: getHighlightMatch(styleSheet.row.searchHighlightStyle)
      })));
    }
  }]);

  return Combobox;
}(React.Component);

export default compose(setDisplayName('Combobox'), wrapOverridableComponent('ComboBox', getDefaultStyleSheet), setPropTypes({
  fieldId: PropTypes.string,
  fieldName: PropTypes.string,
  fieldAriaLabel: PropTypes.string,
  allowCustomValue: PropTypes.bool,
  clearSelectionOnStartTyping: PropTypes.bool,
  customerRowRenderer: PropTypes.func,
  //(item = {}, keySuffix = '', showMatch = false) => PropTypes.symbol,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  noMatchTitle: PropTypes.string,
  onChange: PropTypes.func,
  // ({ item: {}, customValue: boolean }) => {}
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onSearch: PropTypes.func,
  // (searchString, matches) => {}
  searchFunction: PropTypes.func.isRequired,
  // (list, searchString) => Array<Suggestion>
  options: PropTypes.arrayOf(PropTypes.shape({
    alternatives: PropTypes.arrayOf(PropTypes.string),
    icon: PropTypes.string,
    label: PropTypes.string.isRequired,
    disabled: PropTypes.bool
  })),
  optionsTitle: PropTypes.string,
  showOptions: PropTypes.bool,
  showSuggestions: PropTypes.bool,
  warning: PropTypes.bool,
  'data-cid': PropTypes.string,
  fieldTooltip: PropTypes.string,
  fieldTooltipDoNotFold: PropTypes.bool,
  arrow: PropTypes.string,
  autoCapitalize: PropTypes.string,
  autoComplete: PropTypes.string,
  autoCorrect: PropTypes.string,
  spellCheck: PropTypes.string
}), defaultProps({
  clearSelectionOnStartTyping: true,
  noMatchTitle: 'No matches for |SEARCH|',
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onSearch: function onSearch() {},
  options: [],
  showOptions: true,
  showSuggestions: true,
  searchFunction: getMatchingSuggestions,
  autoCapitalize: 'none',
  autoComplete: 'off',
  autoCorrect: 'off',
  spellCheck: 'false'
}), withPropDeprecationWarning({
  name: 'fieldTooltipDoNotFold',
  removalDate: 'v5.0.0'
}), withPropDeprecationWarning({
  name: 'errorLabel',
  removalDate: 'v5.0.0'
}), withPropDeprecationWarning({
  name: 'warningLabel',
  removalDate: 'v5.0.0'
}))(Combobox);
//# sourceMappingURL=index.js.map